import { Injectable } from '@angular/core';
import { ToastButton, ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastMachineService {

  constructor(private toaster: ToastController) { }

  async toastMachine(msg: string, color: string, duration: number, buttons?: ToastButton[]) {
    const TOAST = await this.toaster.create({
      message: msg,
      color,
      duration,
      cssClass: 'toast',
      position: 'top',
      buttons
    });

    await TOAST.present();
  }

}
